import { checkDiff } from '../../../utils/formValidation/errorCheckingFunctions';
import { getReqMessage } from '../../../utils/formValidation/errorMessageFunctions';

export const validate = (rows, payload, initialState) => {
    let newErrors = {};

    if (rows.some((el) => !el.documentTypeId)) {
        rows.forEach((el) => {
            if (!el.documentTypeId) {
                newErrors = {
                    ...newErrors,
                    [`documentTypeId-${el.id}`]: {
                        error: true,
                        message: getReqMessage('Document type')
                    }
                };
            }
        });
    }

    let initial = [];
    initialState.forEach((el) => {
        // eslint-disable-next-line
        const { dateAdded, documentType, ...rest } = el;
        initial = [...initial, rest];
    });
    if (Object.keys(newErrors).length < 1) newErrors = checkDiff(payload, initial);

    return newErrors;
};
